import { formatBadgeCount } from '@/lib/format-badge-count';
import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import React from 'react';

interface CounterBadgeProps extends BoxProps {
  count: number;
  /** On the selected row, the figure lights up with the label. */
  active?: boolean;
}

/**
 * Sidebar counter pill (Inbox unread, affiliates, invitations, mentions...).
 * Flat white wash on the dark menu, right-aligned by its parent via
 * `margin-left: auto`. A zero count renders an empty pill, so a row that keeps
 * the slot reserved can hide it without the figure being read.
 */
const CounterBadge: React.FC<CounterBadgeProps> = ({ count, active = false, ...rest }) => (
  <Box
    as="span"
    ml="auto"
    minW="20px"
    h="19px"
    px="6px"
    display="inline-flex"
    alignItems="center"
    justifyContent="center"
    flexShrink={0}
    rounded="full"
    bg="navDark.badgeBg"
    color={active ? 'navDark.textStrong' : 'navDark.badgeText'}
    fontFamily="heading"
    fontSize="11px"
    fontWeight={600}
    fontVariantNumeric="tabular-nums"
    lineHeight="1"
    {...rest}
  >
    {count > 0 ? formatBadgeCount(count) : null}
  </Box>
);

export default CounterBadge;
